import { render, staticRenderFns } from "./Relays.vue?vue&type=template&id=a62614c2&"
import script from "./Relays.vue?vue&type=script&lang=ts&"
export * from "./Relays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports